<div class="row justify-content-center align-content-center" style="height: 100%">
  <div class="col-4 justify-content-center">
    <div class="card b">
      <div class="card-header bg-gray-lighter text-bold">
        <h4 class="m-0 text-center">
          {{
            "navigation.links.customer.profile.subcategories.titles.ACCOUNT" | translate
          }}
        </h4>
      </div>
      <div class="card-body px-5">
        <form [formGroup]="passwordForm">
          <div class="">
            <mat-form-field>
              <mat-label>{{
                "forms.labels.account.CURRENTPASSWORD" | translate
              }}</mat-label>
              <input matInput formControlName="password" type="password" required />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>{{ "forms.labels.account.NEWPASSWORD" | translate }}</mat-label>
              <div style="display: flex; align-items: center; gap: 10px">
                <input
                  style="position: relative; padding-right: 65px"
                  matInput
                  formControlName="newPassword"
                  required
                  class="form-control"
                  autocomplete="off"
                  [type]="passwordIsVisible ? 'text' : 'password'"
                  id="newPassword"
                  [(ngModel)]="newPassword"
                />
                <!-- <div style="position: absolute; right: 55px; display: flex;gap:5px ">
                             
                          </div> -->
                <button
                  type="button"
                  (click)="togglePasswordVisibility()"
                  style="
                    padding: 0;
                    cursor: pointer;
                    background: none;
                    border: none;
                    outline: none;
                  "
                >
                  @if (passwordIsVisible) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-eye-slash"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                      />
                      <path
                        d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                      />
                      <path
                        d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                      />
                    </svg>
                  } @else {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-eye"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                      />
                      <path
                        d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                      />
                    </svg>
                  }
                </button>
                <button
                  type="button"
                  (click)="generatePasword()"
                  style="
                    padding: 0;
                    cursor: pointer;
                    background: none;
                    border: none;
                    outline: none;
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-clockwise"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                    />
                    <path
                      d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"
                    />
                  </svg>
                </button>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style="width: 23px; height: 23px; cursor: pointer; margin: 0"
                  (click)="copyToClipboard($event)"
                >
                  <path
                    d="m320 448v40c0 13.255-10.745 24-24 24h-272c-13.255 0-24-10.745-24-24v-368c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56zm0-344v-104h-168c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-264h-104c-13.2 0-24-10.8-24-24zm120.971-31.029-65.942-65.942a24 24 0 0 0 -16.97-7.029h-6.059v96h96v-6.059a24 24 0 0 0 -7.029-16.97z"
                  />
                </svg>
              </div>
            </mat-form-field>
            <div
              id="password-error-message-container"
              class="password-error-message-container"
              *ngIf="
                errors.upper ||
                errors.lower ||
                errors.number ||
                errors.symbol ||
                errors.minlength
              "
            >
              <span *ngIf="errors.upper" class="password-error-message">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-circle text-danger"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                  />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
                <label>{{ "forms.errors.UPPERCASE" | translate }}</label>
              </span>
              <span *ngIf="errors.lower" class="password-error-message">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-circle text-danger"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                  />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
                <label>{{ "forms.errors.LOWERCASE" | translate }}</label>
              </span>
              <span *ngIf="errors.number" class="password-error-message">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-circle text-danger"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                  />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
                <label>{{ "forms.errors.NUMBER" | translate }}</label>
              </span>
              <span *ngIf="errors.symbol" class="password-error-message">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-circle text-danger"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                  />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
                <label>{{ "forms.errors.SYMBOL" | translate }}</label>
              </span>
              <span *ngIf="errors.minlength" class="password-error-message">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-circle text-danger"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                  />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
                <label>{{ "forms.errors.PASSWORDLENGHT" | translate }}</label>
              </span>
            </div>
            <div
              *ngIf="
                newPassword?.length > 0 &&
                !errors.upper &&
                !errors.lower &&
                !errors.number &&
                !errors.symbol &&
                !errors.minlength
              "
              style="width: 100%; margin: 10px 0"
            >
              <div class="password-strength-bar" [ngClass]="strength"></div>
              <div style="text-align: center; font-size: 14px">Password Strength</div>
            </div>
          </div>
          <div>
            <mat-form-field>
              <mat-label>{{
                "forms.labels.account.CONFIRMPASSWORD" | translate
              }}</mat-label>
              <input
                matInput
                formControlName="confirmPassword"
                type="password"
                required
              />
            </mat-form-field>
          </div>

          <div style="justify-content: space-evenly; display: flex; margin-top: 20px">
            <button class="btn btn-danger" type="button" (click)="navigateToLogin()">
              {{ "buttons.ABORT" | translate }}
            </button>
            <button class="btn btn-success" type="button" (click)="updatePassword()">
              {{ "routes.profile.BUTTON" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <div style="text-align: center">
      <label>{{ "IntialPassword" | translate }}</label>
    </div>
  </div>
</div>
